import React from "react";
import Text from "./Text";

import TextF1 from "./TextF1";
import TextF5 from "./TextF5";
import { MediumContainer } from "./Grid";
import styled from "styled-components";
import Box from "./Box";
import StyledLink from "./StyledLink";

import { themeGet } from "styled-system";

import bannerPart1Url from "../images/banner-part-1.svg";
import bannerPart2Url from "../images/banner-part-2.svg";
import bannerPart3Url from "../images/banner-part-3-2.svg";
import bannerPart4Url from "../images/banner-part-4.svg";
import bannerPart5Url from "../images/banner-part-5.svg";
import bannerPart6Url from "../images/banner-part-6.svg";

const Wrapper = styled(MediumContainer)`
  position: relative;
  width: 100%;
  height: 100%;
`;

const BannerWrapper = styled(Box)`
  position: relative;
  margin: 0;
  background: ${props =>
    props.part == 1
      ? "#FF556E"
      : props.part == 2
      ? "#8A8ED8"
      : props.part == 3
      ? "#50B9E8"
      : props.part == 4
      ? "#E15FBD"
      : props.part == 5
      ? "#00B5AA"
      : "#FFC07F"};
  height: 40vh;
  min-height: ${props => (props.section ? "250px" : "450px")};
  max-height: ${props => (props.section ? "450px" : "600px")};
  img {
    z-index: 5;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    max-width: 100%;
    height: auto;
    display: block;
    bottom: 0;
  }
`;

const Heading = styled(TextF1)`
  text-align: center;
  color: white;
  margin: 0;
`;

const SubHeading = styled(Text)`
  font-size: 1rem;
  color: white;
  margin-top: 0;
  margin-bottom: 1rem;
  text-align: center;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
`;

const ColorBox = styled(Box)`
  height: ${props => (props.totalheight ? props.totalheight : "100%")};
  width: 100%;
  position: absolute;
  z-index: 1;
`;

const NextButton = styled(StyledLink)`
  color: #4844a3;
  background: #fff;
  border: 2px solid #fff;
  display: block;
  font-size: 0.875rem;
  border-radius: 90px;
  padding: 0.75rem 1.5rem;
  font-family: ${themeGet("fonts.TTNormsProBold")};
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;
  width: 180px;
  text-align: center;
  transition: all 0.2s ease;
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.04);
  :hover {
    background: #4844a3;
    border: 2px solid #4844a3;
    color: #fff;
  }
  @media screen and (min-width: 38em) {
    padding: 1rem 3rem;
    font-size: 1rem;
  }
`;
const Illustration = props => {
  switch (props.part) {
    case 1:
      return <img src={bannerPart1Url} />;
    case 2:
      return <img src={bannerPart2Url} />;
    case 3:
      return <img src={bannerPart3Url} />;
    case 4:
      return <img src={bannerPart4Url} />;
    case 5:
      return <img src={bannerPart5Url} />;
    case 6:
      return <img src={bannerPart6Url} />;
    default:
      return null;
  }
};

const BannerIllustration = props => {
  const { part, section, subHeading, heading, partLink, start } = props;
  return (
    <BannerWrapper part={part} section={section}>
      <Wrapper>
        <Illustration part={part} />
        <Box
          display="flex"
          width="100%"
          height="80%"
          justifyContent="center"
          itemsAlign="center"
          zIndex="5"
          position="relative"
        >
          {!section ? (
            <Box
              display="flex"
              width="100%"
              alignItems="center"
              justifyContent="center"
            >
              <div>
                <SubHeading>{subHeading}</SubHeading>
                <Heading>{heading}</Heading>
                {partLink && <NextButton to={partLink}>{start} →</NextButton>}
              </div>
            </Box>
          ) : (
            ""
          )}
        </Box>
      </Wrapper>
    </BannerWrapper>
  );
};

export default BannerIllustration;
